<template>
    <div class="analysis">
        <div class="analysis-top">
            <div class="tit">{{ title }}</div>
        </div>
        <div class="analysis-cont">
            <div class="cont-left">
                <!--  发文趋势图 -->
                <trendsChart :chart-data="trendsData" ></trendsChart>   
                <!--  相关文献 -->
                <literatureList ></literatureList>
            </div>
            <div class="cont-right">
                <wordsGraph ></wordsGraph>
                <!--  学者信息 -->
                <scholarInfo ></scholarInfo>
            </div>
        </div>
    </div>
</template>
<script>
// 发文趋势图
import TrendsChart from './xkComps/TrendsChart.vue';
// 相关文献
import LiteratureList from './xkComps/literatureList.vue';
// 相关主题词
import WordsGraph from './xkComps/wordsGraph.vue';
// 学者信息
import scholarInfo from './xkComps/scholarInfo.vue';
import defaultTrendsData from './trendsChartData'; 

export default {
    components: {
        TrendsChart,
        LiteratureList,
        WordsGraph,
        scholarInfo,
    },
    data() {
        return {
            title: '学科分析',
            trendsData: defaultTrendsData,
        };
    },
    computed: { 
    },
    mounted() {
        // this.fetchTrendsData();
    },
    methods: {
        // fetchTrendsData() { ... }
    },
};
</script>
<style lang="less" scoped>
.analysis {
    width: 1200px;
    margin: 40px auto;
    padding-bottom: 40px;

    .tit {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        text-align: center;
    }

    .analysis-cont {
        display: flex;
        justify-content: space-between;

        .cont-left {
            width: 720px;
        }

        .cont-right {
            width: 460px;
            // box-shadow: -12px 0px 12px 0px #d3d8dc
        }
    }
}


</style>
